var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('Table',{attrs:{"columns":_vm.columns,"datasource":_vm.datasource,"pagination":_vm.pagination},on:{"opencontrol":_vm.opencontrol,"gettabledata":_vm.gettabledata,"getsearch":_vm.getsearch,"warnmodel":_vm.warnmodel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }